import React, { useEffect, useState } from "react";
import { Box, Button, Container, Paper, Stack } from "@mui/material";
import { TextField, Typography, styled } from "@mui/material";
import { Dialog, DialogContent, Table, TableBody } from "@mui/material";
import { TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import Loader from "../components/Loader";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import Search from "../components/Search";
import Repo from "../../Repository/Repo";
import DeleteDialog from "../reusableComponents/DeleteDialog";
import { Toast } from "../components/Toast";

const ValueBox = styled(Box)({
  background: "#E2FFE3",
  height: "40px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginTop: "10px",
});

function ViewIncentives({ open, onClose, user, onClear }) {
  const [state, setState] = useState({
    loading: false,
    searchText: "",
    records: [],
    selected: "",
    deleteModal: false,
    payModal: false,
    amount: 0,
  });

  useEffect(() => {
    getIncentives();
  }, []);

  const handleInput = (e) => {
    const { name, value } = e.target;
    if (value > user?.incentive) {
      setState((prev) => ({ ...prev, [name]: prev[name] }));
      Toast("info", "Can't pay more than Incentive amount");
    } else {
      setState((prev) => ({ ...prev, [name]: value }));
    }
  };

  const getIncentives = async () => {
    setState((prev) => ({ ...prev, loading: true }));
    let { data } = await Repo.incentive({
      request: {
        method: "getEmployeeIncentives",
        data: {
          company_code: localStorage.getItem("companyCode"),
          employeeId: user.userId,
        },
      },
    });
    console.log("data:", data);
    let records = data.response.data.incentivesArr;
    setState((prev) => ({ ...prev, records, loading: false }));
  };
  const payIncentive = async () => {
    try {
      let { data } = await Repo.salary({
        request: {
          method: "updateSalary",
          data: {
            _id: user._id,
            incentive: state.amount,
          },
        },
      });
      if (data.response.status.statusCode == 200) {
        Toast("success", "Incentive Paid Successfully");
      } else {
        Toast("error", "Incentive not added");
      }
      onClose();
      onClear();
    } catch (err) {
      console.log(err);
      Toast("error", "Error");
      toggle("", "payModal");
      onClose();
      onClear();
    }
  };
  const deleteRecord = async () => {
    try {
      let { data } = await Repo.incentive({
        request: {
          method: "deleteIncentive",
          data: {
            _id: state.selected._id,
          },
        },
      });
      if (data.response.status.statusCode == 200) {
        Toast("success", "Deleted Successfully");
      } else {
        Toast("error", "Incentive Not Deleted");
      }
      toggle("", "deleteModal");
      getIncentives();
    } catch (err) {
      console.log(err);
      Toast("error", "Error");
      toggle("", "deleteModal");
      getIncentives();
    }
  };

  const handleSearch = (e) => {
    const { name, value } = e.target;
    setState((prev) => ({ ...prev, [name]: value }));
  };

  const toggle = (item = "", name) => {
    setState((prev) => ({
      ...prev,
      selected: item,
      [name]: !prev[name],
    }));
  };

  const filtered = () => {
    if (state.searchText) {
      const filteredItems = state.records.filter(
        (i) =>
          i.itemName && i?.itemName.toLowerCase().includes(state.searchText)
      );
      console.log("filteredItems:", filteredItems);
      return filteredItems;
    } else {
      return state.records;
    }
  };
  return (
    <Dialog title="Detail" open={open} onClose={onClose}>
      <DialogContent>
        <Search
          name={"searchText"}
          text={"Search..."}
          value={state.searchText}
          onChange={handleSearch}
        />
        {user?.incentive && (
          <Stack marginTop="10px" width="100%" alignItems="flex-end">
            <Button
              variant="contained"
              sx={{ width: "150px", textTransform: "none" }}
              onClick={() => toggle("", "payModal")}
            >
              Pay Incentive
            </Button>
          </Stack>
        )}
        <Box sx={{ mt: 3, minWidth: "450px" }}>
          {!state.loading && (
            <TableContainer component={Paper}>
              <Table
                sx={{ minWidth: 450 }}
                size="small"
                aria-label="a dense table"
              >
                <TableHead>
                  <TableRow>
                    <TableCell>Item</TableCell>
                    <TableCell>Incentive %</TableCell>
                    <TableCell>Incentive Amount</TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filtered()?.map((row, i) => (
                    <TableRow key={i}>
                      <TableCell
                        component="th"
                        scope="row"
                        sx={{ width: "210px" }}
                      >
                        {row?.itemName}
                      </TableCell>
                      <TableCell
                        component="th"
                        scope="row"
                        sx={{ width: "120px" }}
                      >
                        {row?.incentivePer}
                      </TableCell>
                      <TableCell
                        component="th"
                        scope="row"
                        sx={{ width: "150px" }}
                      >
                        {row?.incentiveAmount}
                      </TableCell>
                      <TableCell
                        sx={{ width: "30px" }}
                        component="th"
                        scope="row"
                      >
                        <DeleteForeverIcon
                          sx={{ cursor: "pointer", color: "#DE2727" }}
                          onClick={() => toggle(row, "deleteModal")}
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
          {state.loading && <Loader loading={state.loading} />}
        </Box>
      </DialogContent>
      <DeleteDialog
        title="Pay Incentive"
        open={state.deleteModal}
        onClose={() => toggle("", "deleteModal")}
        onClickYes={deleteRecord}
      />
      <Dialog open={state.payModal} onClose={() => toggle("", "payModal")}>
        <DialogContent>
          <Container>
            <Typography
              variant="h6"
              sx={{ textAlign: "center", color: "#4EAF50" }}
            >
              Pay Incentive!
            </Typography>

            <TextField
              fullWidth
              size="small"
              label="Enter amount"
              sx={{ borderRadius: "6px", fontSize: "12px", my: 2 }}
              variant="outlined"
              value={state.amount}
              type="number"
              name="amount"
              onChange={handleInput}
            />

            <Typography
              varinat="h6"
              sx={{ textAlign: "center", color: "#4EAF50" }}
            >
              Incentive!
            </Typography>

            <ValueBox>
              <Typography variant="body1">{user?.incentive || 0}</Typography>
              <Typography variant="body1" sx={{ ml: 1 }}>
                Rs
              </Typography>
            </ValueBox>

            {state.loading && <Loader loading={state.loading} />}
            {!state.loading && (
              <Stack
                marginTop="20px"
                direction="row"
                justifyContent="space-evenly"
                spacing={10}
              >
                <Button
                  fullWidth
                  variant="contained"
                  sx={{ background: "rgb(138, 138, 138) !important" }}
                  onClick={() => toggle("", "payModal")}
                >
                  Cancel
                </Button>
                <Button fullWidth variant="contained" onClick={payIncentive}>
                  Pay
                </Button>
              </Stack>
            )}
          </Container>
        </DialogContent>
      </Dialog>
    </Dialog>
  );
}

export default ViewIncentives;
